module.exports = __webpack_public_path__ + "static/media/19ESCAP9.4d291d3e.jpg";